import React, { useContext, useEffect, useState } from "react";
import { ProyectosContext } from "../../context/ProyectosContext";
import { PartidasContext } from "../../context/PartidasContext";
import { EntradasContext } from "../../context/EntradasContext";
import { AppConfigContext } from "../../context/AppConfigContext";
import { AvanceModeContext } from "../../context/AvanceModeContext";
import { AuthContext } from "../../context/AuthContext";
import BitacoraInput from "../bitacora/BitacoraInput";
import Entradas from "../bitacora/Entradas";
import AvancePickerMobile from "./AvancePickerMobile";
import ConceptoProgressBar from "../global/ConceptoProgressBar";
import ItemDetail from "./ItemDetail";
import IconItem from "../global/IconItem";
import { IonLabel, IonSegment, IonSegmentButton } from "@ionic/react";
import ItemAlertas from "./ItemAlertas";
import { getValue } from "../../utils";

const PartidaDetail = ({ idProyecto, partida, callback }) => {
  const [tab, setTab] = useState("details");

  const {
    getSinglePartida,
    postSinglePartida,
    setPropertySinglePartida,
    postAvancePartida,
  } = useContext(PartidasContext);

  const { postEntrada } = useContext(EntradasContext);

  const { proyecto } = useContext(ProyectosContext);

  const appconfig = useContext(AppConfigContext);
  const { inputType } = useContext(AvanceModeContext);

  const { user } = useContext(AuthContext);

  const { permiso, idPermiso, modo_avance } = proyecto || {};

  const canEditProgress =
    ["admin", "supervisor", "contratista"].includes(permiso) ||
    [3, 6].includes(parseInt(idPermiso));

  // Partidas only take avance when the project tracks progress at the partida level.
  const showAvancePicker =
    (modo_avance || "destajo") === "partida" &&
    getValue(appconfig, "progress") !== "money" &&
    canEditProgress;

  const postAvance = (cont, isManual) => {
    postAvancePartida(
      partida.idPartida,
      cont,
      idProyecto,
      () => {
        fetchPartida();
        if (callback) callback();
      },
      isManual,
    );
  };

  // Real-vs-programado bar — same one used in PartidaMobile / ProgresoPartidaChart.
  const realPct =
    getValue(appconfig, "progress") === "money"
      ? parseInt(partida.progreso)
      : parseInt(partida.real * 100);
  const programadoPct = parseInt(Number(partida.programado) * 100);
  const diff = programadoPct - realPct;
  let programadoClass = "programado-gradiente";
  if (diff > 10) programadoClass = "diferencial-gradiente";
  else if (diff >= 5) programadoClass = "pagos-gradiente";

  useEffect(() => {
    fetchPartida();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchPartida = () => {
    getSinglePartida(idProyecto, partida.idPartida);
  };

  const postComentario = (message, files) => {
    postEntrada(
      idProyecto,
      { message, files, idPartida: partida.idPartida },
      fetchPartida,
    );
  };

  const renderComments = () => {
    if (tab === "comments") {
      return (
        <div
          className="d-flex flex-column"
          style={{ height: "calc(85vh - 110px)" }}
        >
          <div
            className="flex-grow-1 overflow-auto"
          >
            {Array.isArray(partida.Entradas) && partida.Entradas.length > 0 ? (
              <Entradas
                user={user}
                height="auto"
                idProyecto={idProyecto}
                entradas={partida.Entradas}
              />
            ) : (
              <p className="text-muted small">No hay comentarios creados</p>
            )}
          </div>
          <div className="flex-shrink-0">
            <BitacoraInput modifier={postComentario} />
          </div>
        </div>
      );
    }
  };

  const renderPreconditions = () => {
    const dependences = [
      {
        idProyecto: 10,
        idPartida: 71,
        punto_critico: null,
        nombre: "PRELIMINARES",
        orden: 1,
        ponderacion: "2",
        fecha_inicio: "2023-10-02T00:00:00.000Z",
        fecha_fin: "2023-10-07T00:00:00.000Z",
        notificar: null,
        programado: "1.00",
        real: "0.00",
        responsable: null,
        nombre_responsable: null,
        correo_responsable: null,
        ejecutado: "0.0000",
        autorizado: "1075366.3230",
        progreso: "0.00",
      },
      {
        idProyecto: 10,
        idPartida: 72,
        punto_critico: null,
        nombre: "TERRACERIAS",
        orden: 2,
        ponderacion: "42",
        fecha_inicio: "2023-10-09T00:00:00.000Z",
        fecha_fin: "2023-10-14T00:00:00.000Z",
        notificar: null,
        programado: "1.00",
        real: "0.00",
        responsable: null,
        nombre_responsable: null,
        correo_responsable: null,
        ejecutado: "0.0000",
        autorizado: "18847111.2623",
        progreso: "0.00",
      },
    ];
    if (
      Array.isArray(dependences) &&
      partida.idPartida === 74
      // tab === "alerts"
    ) {
      return dependences.map((current) => (
        <div className="col-6">
          <IconItem
            name="Predecesora"
            icon={
              parseInt(current.progreso) === 1
                ? "check text-success"
                : "lock text-secondary"
            }
          >
            <p className="mb-0">{current.nombre}</p>
          </IconItem>
        </div>
      ));
    }
  };

  const renderDetails = () => {
    if (tab === "details") {
      return (
        <div className="flex-grow-1 overflow-auto pb-3">
          <ItemDetail
            id="idPartida"
            item={partida}
            itemLabel="Partida"
            proyecto={proyecto}
            callback={callback}
            saveItem={postSinglePartida}
            modifier={setPropertySinglePartida}
            progressBar={
              <ConceptoProgressBar
                idPartida={partida.idPartida}
                programado={programadoPct}
                real={realPct}
                handleClick={() => {}}
                programadoClass={programadoClass}
                height={16}
                showLabels
              />
            }
            avancePicker={
              showAvancePicker ? (
                <AvancePickerMobile
                  permitirExcedente
                  progreso={parseInt(partida.generalPartida)}
                  setCantidad={postAvance}
                  intervalo={1}
                  limite={100}
                  inputType={inputType}
                />
              ) : null
            }
          />
        </div>
      );
    }
  };

  const renderAlerts = () => {
    if (tab === "alerts") {
      return (
        <div className="flex-grow-1 overflow-auto pb-3">
          <ItemAlertas idKey={"idPartida"} idItem={partida["idPartida"]} />{" "}
        </div>
      );
    }
  };
  return (
    <div
      className="container-fluid d-flex flex-column pt-4 h-100"
    >
      <IonSegment value={tab} className="mb-3 flex-shrink-0">
        <IonSegmentButton onClick={() => setTab("details")} value="details">
          <IonLabel>Detalles</IonLabel>
        </IonSegmentButton>
        <IonSegmentButton onClick={() => setTab("alerts")} value="alerts">
          <IonLabel>Alertas</IonLabel>
        </IonSegmentButton>
        <IonSegmentButton onClick={() => setTab("comments")} value="comments">
          <IonLabel>Comentarios</IonLabel>
        </IonSegmentButton>
      </IonSegment>

      {renderDetails()}
      {renderAlerts()}
      {renderPreconditions()}

      {renderComments()}
    </div>
  );
};

export default PartidaDetail;
